export default __webpack_public_path__ + "static/media/Graphics_Short-Sleeve-Mock-Up-min.b115f770.png";